/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileIllustrator32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#051E25"
                fillRule="nonzero"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                fillRule="nonzero"
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill="#FF9400"
                d="M20.42 15.805c.072 0 .108.027.108.107v6.982c0 .07-.018.106-.107.106h-1.393c-.09 0-.117-.044-.117-.115v-6.973h-.009c0-.071.027-.107.108-.107h1.41zm-5.813-2.557c.063 0 .09.017.108.088l2.857 9.549c.018.07 0 .115-.072.115h-1.49c-.072 0-.117-.018-.135-.08l-.737-2.663h-2.875l-.71 2.655c-.018.07-.045.088-.135.088h-1.32c-.09 0-.109-.027-.09-.133l2.551-8.796c.045-.16.072-.301.09-.735 0-.062.027-.088.072-.088h1.887zm-.917 1.416h-.018c-.188 1.035-.665 2.787-1.042 4.159h2.13c-.252-.982-.845-3.124-1.07-4.16zM19.72 13c.548 0 .916.363.916.903 0 .584-.386.902-.934.902-.521 0-.899-.318-.899-.902 0-.567.404-.903.917-.903z"
            />
        </g>
    </AccessibleSVG>
);

export default FileIllustrator32;
